// T-176 (v1.8.55, Session 43): Anzahlungssatz je Tourart in der Tourarten-Verwaltung (Eingabe in Prozent, API als Bruchwert).
// Leer = Standard aus den Einstellungen (API-Wert 0). Reine Funktionen, getestet in tourartAnzahlung.test.ts.

/** Prozent-Text aus dem gespeicherten Bruchwert (0.4 -> "40"), leer ohne eigenen Satz. */
export function anzahlungProzentText(satz?: number | null): string {
  if (typeof satz !== 'number' || !(satz > 0 && satz < 1)) return '';
  return String(Math.round(satz * 10000) / 100);
}

/** Bruchwert für die API aus dem Prozent-Text ("40" -> 0.4), leer -> 0 (Standard), ungültig -> null. */
export function anzahlungAusProzentText(text: string): number | null {
  const t = (text ?? '').trim().replace(',', '.');
  if (t === '') return 0;
  const p = Number(t);
  if (!Number.isFinite(p) || p < 1 || p > 99) return null;
  return Math.round(p * 100) / 10000;
}
